export default {
    tasks: {
        taskManagement: "Administración de tareas",
        serviceName: "Servicio",
        taskName:"Tarea",
        enabled:"Activado",
        runJobs: 'Ejecutar trabajos',
        enableJobs: 'Habilitar trabajos',
        disableJobs: 'Desactivar trabajos',
        maxRowsSelection: 'Se pueden seleccionar {limit} filas máximas',
        tasksSubmissionSuccess: 'Las tareas seleccionadas se enviaron correctamente',
        tasksSubmissionFail: 'No se pudieron enviar las tareas seleccionadas',
        customer: "Cliente",
        schedule: "Calendario",
        priority: "Prioridad",
        maxRunTime: "Tiempo máximo de ejecución (minutos)",
        nextStartTime: "Siguiente hora de inicio",
        lastStartTime: "Última hora de inicio",
        lastStatus: "Último estado",
        taskType: "Tipo de tarea",
        details: "Detalles de la tarea",
        general: "General",
        history: "Historia",
        startTime: "Hora de inicio",
        endTime: "Hora de finalización",
        status: "Estado",
        totalTime: "Tiempo total (segundos)",
        message: "Mensaje",
        results: "Resultados",
        lastRunDuration:"Duración de la última ejecución (segundos)",
        lastRunDurationTooltip:"El tiempo de ejecución del último trabajo en segundos",
        numFailures: "Número de fallas",
        numFailuresTooltip: "Número de fallas en las últimas 100 ejecuciones",
        durationDelta: "Delta de duración",
        durationDeltaTooltip: "El cambio porcentual de duración del trabajo entre la duración media de las 3 ejecuciones de trabajos más antiguas y las 3 más recientes. Se excluyen las ejecuciones de reabastecimiento y las primeras ejecuciones para el historial incompleto.",
        durationDeltaInfo: "Duración Delta Info",
        durationDeltaInfoTooltip: "Los valores utilizados para calcular la duraciónDelta",
        priorityValues: {
            HIGH: "HIGH",
            MEDIUM: "MEDIUM",
            LOW: "LOW"
        },
        taskTypeValues: {
            SYSTEM: "SYSTEM",
            USER: "USER"
        },
        statusValues: {
            NEVER_RUN: "NEVER_RUN",
            STARTED: "STARTED",
            FINISHED: "FINISHED",
            FAILED: "FAILED"
        },
        services: {
            alarms: "Alarmas",
            history: "Historia",
            fwdl: "FWDL",
            'radios-tasks': "Tareas de radio",
            'towers-processing': "Procesamiento de estación base",
            'towers-tasks': "Tareas de la estación base"
        },
        configureCommsHubExport: 'Configurar la hora de inicio de CommsHubExport'
    }
}
